module.exports = __webpack_public_path__ + "static/media/FB-Landing-Page-graphic4.0d2b9198.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NYCMeetUpLanding/images/FB-Landing-Page-graphic4.png
// module id = 1552
// module chunks = 0